import axios from 'axios'
import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import LoadingV2 from 'components/LoadingV2'
import { capitalizeEveryWord, getTimelineItem } from 'helpers'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'
import { ArrowLeft, FileText } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Card, CardBody, Col, Progress, Row, Spinner } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'
import ModalPartialPayment from '../ModalPartialPayment'
import { useFetchTalanginInvoiceDetailQuery } from '../talanginInvoiceApiSlice'
import { setSelectedRow, toggleModalPartial } from '../talanginInvoiceSlice'

const DetailTalanginInvoice = () => {
  const dispatch = useDispatch()
  const { token } = useSelector((s) => s.auth)
  const { row } = useLocation().state

  const { data, isLoading, refetch } = useFetchTalanginInvoiceDetailQuery(
    {
      id: row?.amountPlusInterest
        ? row?.id
        : row?.escrowpayment?.userpinjamanId,
    },
    {
      skip: !row?.escrowpayment?.userpinjamanId ?? !row?.id,
    },
  )

  const today = moment().tz('Asia/Jakarta').startOf('day').toDate()

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [loadingInvoice, setLoadingInvoice] = useState(false)
  const [history, setHistory] = useState([])

  //   UNDUH PROFORMA INVOICE
  const downloadAsPdf = (data, url, type) => {
    setLoadingInvoice(true)
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...{ responseType: 'blob' },
      })
      .then((response) => {
        const defName = `TRX/ID/${data.loan ? 'PMG-' : ''}${data.id}`
        var pdfNumber = defName
        if (data.deponumbers && data.deponumbers.length > 1) {
          pdfNumber = data.deponumbers[0].fullNumber
          if (data.loan || data.creditRequested > 0) {
            pdfNumber.replace(type, `${type}/PMG-`)
          }
        }
        var filename = `${pdfNumber.replaceAll('/', '-')}.pdf`
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
        const blobFile = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blobFile)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(function (error) {})
      .finally(() => setLoadingInvoice(false))
  }

  //   UNDUH CLAIM
  const downloadClaimPdf = (data, url, type) => {
    setLoading(true)
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...{ responseType: 'blob' },
      })
      .then((response) => {
        const defName = `TRX/ID/${data.loan ? 'PMG-' : ''}${data.id}`
        var pdfNumber = defName
        if (data.deponumbers && data.deponumbers.length > 1) {
          pdfNumber = data.deponumbers[0].fullNumber
          if (data.loan || data.creditRequested > 0) {
            pdfNumber.replace(type, `${type}/PMG-`)
          }
        }
        var filename = `${pdfNumber.replaceAll('/', '-')}.pdf`
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
        const blobFile = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blobFile)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(function (error) {})
      .finally(() => setLoading(false))
  }

  const subtotal =
    data?.escrowpayment?.amount +
    (data?.previousUserPinjamanId
      ? data?.escrowpayment?.escrowcreditv2?.margin2
      : data?.escrowpayment?.escrowcreditv2?.margin)

  const feeTx = data?.escrowpayment?.escrowcreditv2?.useFreeTx
    ? 0
    : (data?.rolloverCostCreditV2?.feeTx ?? 0)

  const vat = data?.escrowpayment?.escrowcreditv2?.useFreeTx
    ? 0
    : data?.escrowpayment?.escrowcreditv2?.feeTxVAT

  const amountToPay =
    data?.status == 'PAIDOFF'
      ? 0
      : data?.netOutstanding
        ? data?.netOutstanding
        : data?.amount +
          data?.fineData?.totalFine -
          data?.discountData?.discount

  const totalAmountToPay = data?.escrowpayment?.escrowcreditv2?.useFreeTx
    ? data?.escrowpayment?.escrowcreditv2?.totalVAT +
      (subtotal || data?.amountPlusInterest) +
      (data?.escrowpayment?.escrowcreditv2?.feeTx -
        data?.escrowpayment?.escrowcreditv2?.feeTxVAT) +
      (data?.partialpaymentData?.fine || data?.fineData?.totalFine)
    : data?.escrowpayment?.escrowcreditv2?.feeTxVAT +
      data?.escrowpayment?.escrowcreditv2?.totalVAT +
      (subtotal || data?.amountPlusInterest) +
      (data?.escrowpayment?.escrowcreditv2?.feeTx -
        data?.escrowpayment?.escrowcreditv2?.feeTxVAT) +
      (data?.partialpaymentData?.fine || data?.fineData?.totalFine)

  const paidAmout = totalAmountToPay - amountToPay

  const isAgency = data?.claim?.pmToBuyer?.download ? true : false

  let totalUpfront = 0
  if (data?.creditVersion === 2) {
    if (!data?.previousUserPinjamanId) {
      totalUpfront =
        data?.escrowpayment?.escrowcreditv2?.upfront +
        data?.escrowpayment?.escrowcreditv2?.totalVAT +
        (isAgency
          ? data?.partialpaymentData?.existingPartialPayment
          : data?.escrowpayment?.escrowcreditv2?.margin)
    } else {
      if (
        data?.escrowpayment?.escrowcreditv2?.margin2 &&
        data?.previousUserPinjamanId
      ) {
        totalUpfront =
          data?.escrowpayment?.escrowcreditv2?.upfront2 +
          data?.escrowpayment?.escrowcreditv2?.margin2
      } else {
        totalUpfront += data?.escrowpayment?.escrowcreditv2?.upfront2
          ? data?.escrowpayment?.escrowcreditv2?.upfront2
          : data?.escrowpayment?.escrowcreditv2?.upfront +
            data?.escrowpayment?.escrowcreditv2?.margin2
      }
    }
  } else {
    totalUpfront = data?.collateral
  }

  const isPaidOff = data?.status === 'PAIDOFF'

  const toggle = () => dispatch(toggleModalPartial())

  const isDisabledButtonExtend =
    data?.status !== 'DISBURSED' ||
    data?.previousUserPinjamanId ||
    new Date(data?.dueDate).setHours(0, 0, 0, 0) <
      new Date(today).setHours(0, 0, 0, 0)

  const alurMaker = (data) => {
    let alur = []

    if (data.escrowpayment?.createdAt || data.disbursedDate) {
      alur.push({
        label: 'Pembeli mengajukan talangin',
        date: data.escrowpayment?.createdAt || data.disbursedDate,
      })
    }

    if (data.disbursedDate) {
      if (!data?.previousUserPinjamanId)
        alur.push({
          label: 'Tagihan talangin disetujui',
          date: data?.disbursedDate,
        })
    }

    if (data.rolloverDate)
      alur.push({
        label: 'Pembeli mengajukan perpanjangan tempo pembayaran',
        date: data.rolloverDate,
      })

    for (let i = 0; i < data.partialpayments?.length; i++) {
      let amount = Number(
        data.partialpayments[i].paymentAmount ||
          data.partialpayments[i].partialPaidFine,
      )
      alur.push({
        label:
          'Pembeli membayar tagihan Rp' + newFormatThousandSeparator(amount, 0),
        date: data?.partialpayments[i].createdAt,
      })
    }
    if (data.status == 'PAIDOFF') {
      alur.push({
        label: 'Tagihan lunas',
        date: data?.paidoffDate,
      })
    }

    setHistory(alur)
  }

  useEffect(() => {
    if (data) alurMaker(data)
  }, [data])

  // SUMMARY UNIT AND AMOUNT
  const unitSummary = data?.escrowpayment?.order?.orderitem?.reduce(
    (acc, item) => {
      const unit = item?.unit?.toLowerCase()
      if (!unit) return acc

      if (!acc[unit]) {
        acc[unit] = {
          unit,
          inventoryCount: 0,
          totalAmount: 0,
        }
      }

      acc[unit].inventoryCount += 1
      acc[unit].totalAmount += Number(item?.amount ?? 0)

      return acc
    },
    {},
  )

  const unitSummaryArray = Object.values(unitSummary || {})

  const totalFeeTx = data?.escrowpayment?.escrowcreditv2?.useFreeTx
    ? 0
    : (data?.rolloverCostCreditV2?.feeTx ??
      data?.escrowpayment?.escrowcreditv2?.feeTx)

  if (isLoading) {
    return <LoadingV2 />
  }

  return (
    <div className="w-100 px-3">
      {/* MODAL */}
      <ModalPartialPayment
        row={row}
        amountToPay={amountToPay}
        toggleSidebar={toggle}
      />

      <div className="mt-3">
        <BreadCrumbs
          breadCrumbParent2="Tagihan Talangin"
          breadCrumbParent2Link={'/tagihan-talangin'}
          breadCrumbActive="Detail Tagihan Talangin"
        />
      </div>

      <div>
        <div className="row align-items-center justify-content-between py-3 gy-2">
          <div className="col-auto d-flex align-items-center">
            <ArrowLeft
              size={20}
              className="me-2"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(-1)}
            />
            <h6 className="fw-bold mb-0 text-nowrap">Detail Tagihan Talangin</h6>
          </div>

          <div className="col-auto d-flex align-items-center gap-2 flex-wrap">
            {data?.status === 'DISBURSED' && (
              <Button
                color="primary"
                className="d-flex align-items-center text-nowrap"
                onClick={() => {
                  dispatch(toggleModalPartial())
                }}
              >
                Bayar Tagihan
              </Button>
            )}

            <Button
              outline
              color="primary"
              className="d-flex align-items-center text-nowrap"
              onClick={() => {
                downloadAsPdf(row, data?.invoice?.pmToBuyer?.download, 'INVF')
              }}
              disabled={loadingInvoice}
            >
              {loadingInvoice ? (
                <Spinner size="sm" className="me-1" />
              ) : (
                <FileText size={16} className="me-1" />
              )}
              Unduh {isPaidOff ? 'Invoice' : 'Proforma Invoice'}
            </Button>

            {isAgency && (
              <Button
                outline
                color="primary"
                className="d-flex align-items-center text-nowrap"
                onClick={() => {
                  downloadClaimPdf(
                    row,
                    data?.claim?.pmToBuyer?.download,
                    'INVF',
                  )
                }}
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm" className="me-1" />
                ) : (
                  <FileText size={16} className="me-1" />
                )}
                Unduh Tagihan Klaim Reimbursemen
              </Button>
            )}
          </div>
        </div>

        {/* LEFT AND RIGHT COLUMN */}
        <Row>
          {/* LEFT COLUMN  */}
          <Col md="5">
            {!isPaidOff && (
              <Card
                className="shadow-sm text-center mb-3"
                style={{
                  backgroundColor: '#ECFAFF',
                  border: '1px solid #8ABBCC !important',
                }}
              >
                <CardBody>
                  <P
                    className={`text-center mb-${isDisabledButtonExtend ? '0' : '2'}`}
                  >
                    {new Date(data?.dueDate).setHours(0, 0, 0, 0) <
                    new Date(today).setHours(0, 0, 0, 0)
                      ? 'Anda tidak dapat memperpanjang tempo pembayaran'
                      : data?.previousUserPinjamanId
                        ? 'Anda sudah memperpanjang tempo pembayaran.'
                        : 'Anda dapat memperpanjang tempo pembayaran.'}
                  </P>

                  {!isDisabledButtonExtend && (
                    <Button
                      block
                      color="primary"
                      onClick={() => {
                        dispatch(setSelectedRow(row))
                        navigate('/perpanjang-tempo-pembayaran')
                      }}
                      disabled={isDisabledButtonExtend}
                    >
                      Perpanjang
                    </Button>
                  )}
                </CardBody>
              </Card>
            )}

            <Card className="shadow-sm border-0 mb-3">
              <CardBody>
                <h6 className="fw-semibold mb-3">Informasi tagihan</h6>
                <Row className="mb-3">
                  <Col xs="6" className="fw-light text-sm">
                    Tagihan dari
                  </Col>
                  <Col xs="6" className="fw-semibold text-sm">
                    <div className="d-flex flex-column justify-content-start gap-1">
                      <span>PT PasarMIKRO Global</span>
                      {/* {row?.sellerTokoName && (
                        <small className="fw-light">
                          Mewakili toko: {row?.sellerTokoName}
                        </small>
                      )} */}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs="6" className="fw-light text-sm">
                    Sisa tagihan
                  </Col>
                  <Col
                    xs="6"
                    className="fw-semibold text-sm"
                    style={{ color: isPaidOff ? '#000' : '#b42318' }}
                  >
                    Rp
                    {amountToPay
                      ? newFormatThousandSeparator(Number(amountToPay ?? 0), 0)
                      : '0'}{' '}
                    {isPaidOff && '(Lunas)'}
                  </Col>
                </Row>
                <Row
                  style={{
                    padding: '12px',
                    paddingTop: '0px !important',
                  }}
                >
                  <Card
                    className="shadow-sm border-0"
                    style={{
                      border: isPaidOff && '1px solid #D1FADF',
                      backgroundColor: isPaidOff ? '#F4FFF8' : '#FFFEF8',
                    }}
                  >
                    <CardBody>
                      <div className="d-flex justify-content-between fw-light">
                        <small>Sudah terbayarkan</small>
                        <small>
                          {' '}
                          Rp
                          {paidAmout
                            ? newFormatThousandSeparator(
                                Number(paidAmout ?? 0),
                                0,
                              )
                            : '0'}
                        </small>
                      </div>
                      <Progress
                        value={
                          (Number(paidAmout ?? 0) /
                            Number(totalAmountToPay ?? 0)) *
                          100
                        }
                        color="success"
                        style={{
                          borderRadius: '10px',
                          backgroundColor: '#D1FADF',
                          height: '12px',
                        }}
                      />
                    </CardBody>
                  </Card>
                </Row>

                {data && data?.escrowpaymentId && (
                  <CustomButton
                    outline
                    color="primary"
                    style={{ width: '100%' }}
                    onClick={() => {
                      navigate(
                        `${URL_DETAIL_TRANSACTION}/${data?.escrowpaymentId}?type=BUY`,
                      )
                    }}
                  >
                    Lihat Detail Transaksi
                  </CustomButton>
                )}
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-3">
              <CardBody>
                <h6 className="fw-semibold mb-3">Alur Transaksi</h6>

                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                  {history.map((item, index) =>
                    getTimelineItem(item?.label, item?.date),
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* RIGHT COLUMN */}
          <Col md="7">
            <Card className="shadow-sm border-0 mb-3">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="mb-3">
                    <P bold>Rincian Pesanan</P>
                  </div>
                </div>

                {data?.escrowpayment?.order?.orderitem?.length > 1 && (
                  <div className="group-card-container">
                    {unitSummaryArray?.map((item) => (
                      <div
                        className="group-card"
                        key={item?.unit}
                        style={{ cursor: 'default' }}
                      >
                        <div>
                          <P size="small" color={'#475467'}>
                            {item?.inventoryCount || 0} Inventori •{' '}
                            {newFormatThousandSeparator(item?.totalAmount || 0)}{' '}
                            {capitalizeEveryWord(item?.unit)}
                          </P>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="gap-1">
                  {data?.escrowpayment?.order?.orderitem?.map((e, i) => {
                    return (
                      <div
                        key={i}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div className="d-flex flex-column mb-2">
                          <P>{e?.item?.nameItem ?? e?.SKU ?? '-'}</P>
                          <div className="d-flex gap-2">
                            <P className="text-sm text-primary">
                              {e?.amount} {e?.item?.unit ?? e?.unit} x{' '}
                            </P>{' '}
                            <P className="text-sm text-primary">
                              Rp
                              {newFormatThousandSeparator(
                                isAgency
                                  ? e?.price || 0
                                  : e?.sellPriceBeforeVAT
                                    ? e?.sellPriceBeforeVAT / e?.amount
                                    : e?.price,
                                0,
                              )}
                            </P>
                          </div>
                        </div>
                        <span className="text-primary">
                          Rp
                          {newFormatThousandSeparator(
                            isAgency
                              ? e?.totalPrice || e?.sellPriceBeforeVAT || 0
                              : e?.sellPriceBeforeVAT || e?.totalPrice || 0,
                            0,
                          )}
                        </span>
                      </div>
                    )
                  })}

                  <hr></hr>

                  {isAgency ? (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Biaya layanan (termasuk PPN)</p>
                        <p className="text-primary">
                          Rp{' '}
                          {newFormatThousandSeparator(
                            Number(
                              (data?.previousUserPinjamanId
                                ? data?.escrowpayment?.escrowcreditv2?.margin2
                                : data?.escrowpayment?.escrowcreditv2
                                    ?.margin) ?? 0,
                            ),
                            0,
                          )}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Biaya transaksi (termasuk PPN)</p>
                        <p className="text-primary">
                          Rp {newFormatThousandSeparator(totalFeeTx, 0)}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Uang muka</p>
                        <p className="text-primary">
                          Rp{' '}
                          {totalUpfront
                            ? newFormatThousandSeparator(totalUpfront, 0)
                            : '0'}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>
                          Total dari biaya layanan, biaya transaksi, dan uang
                          muka
                        </p>
                        <p className="text-primary">
                          Rp{' '}
                          {newFormatThousandSeparator(
                            Number(
                              (data?.previousUserPinjamanId
                                ? data?.escrowpayment?.escrowcreditv2?.margin2
                                : data?.escrowpayment?.escrowcreditv2
                                    ?.margin) ?? 0,
                            ) +
                              totalFeeTx +
                              totalUpfront,
                            0,
                          )}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Tanggal pembayaran</p>
                        <p className="text-primary">
                          {moment().format('Do MMM YYYY')}
                        </p>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <p>Nilai Kontrak Awal</p>
                        <p className="text-primary">
                          Rp{' '}
                          {newFormatThousandSeparator(
                            Number(data?.escrowpayment?.creditRequested ?? 0),
                            0,
                          )}
                        </p>
                      </div>
                      {data?.partialpaymentData?.discount > 0 ? (
                        <div className="d-flex justify-content-between align-items-center">
                          <p>Diskon</p>
                          <p className="text-primary">
                            Rp{' '}
                            {newFormatThousandSeparator(
                              Number(data?.partialpaymentData?.discount ?? 0),
                              0,
                            )}
                          </p>
                        </div>
                      ) : null}

                      {data?.partialpaymentData?.fine > 0 ? (
                        <div className="d-flex justify-content-between align-items-center">
                          <p>Denda keterlambatan</p>
                          <p className="text-primary">
                            Rp{' '}
                            {newFormatThousandSeparator(
                              Number(data?.partialpaymentData?.fine ?? 0),
                              0,
                            )}
                          </p>
                        </div>
                      ) : null}
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Pengganti terhadap sisa nilai kontrak pembelian</p>
                        <p className="text-primary">
                          Rp{' '}
                          {newFormatThousandSeparator(
                            Number(
                              data?.partialpaymentData?.nextAmountToComplete ??
                                0,
                            ),
                            0,
                          )}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Tanggal Jatuh Tempo</p>
                        <p className="text-primary">
                          {moment(
                            data?.snapshotCreditV2?.dueDate ||
                              data?.snapshotCreditV2?.duedate,
                          ).format('Do MMM YYYY')}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Denda keterlambatan pembayaran</p>
                        <p className="text-primary">
                          {data?.snapshotCreditV2?.dailyFinePercentage ?? 0}%
                          per hari
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Subtotal</p>
                        <p className="text-primary">
                          Rp
                          {subtotal
                            ? newFormatThousandSeparator(subtotal, 0)
                            : '0'}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p>Biaya transaksi (termasuk PPN)</p>
                        <p className="text-primary">
                          Rp
                          {feeTx ? newFormatThousandSeparator(feeTx, 0) : '0'}
                        </p>
                      </div>
                      {/* <div className="d-flex justify-content-between align-items-center">
                        <span>PPN</span>
                        <span className="text-primary">
                          Rp
                          {vat ? newFormatThousandSeparator(vat, 0) : '0'}
                        </span>
                      </div> */}
                      <hr></hr>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="fw-bold">Total transaksi</p>
                        <p className="text-primary fw-bold">
                          Rp
                          {totalAmountToPay
                            ? newFormatThousandSeparator(totalAmountToPay, 0)
                            : '0'}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Pembayaran diawal</span>
                        <span className="text-primary">
                          Rp
                          {totalUpfront
                            ? newFormatThousandSeparator(totalUpfront, 0)
                            : '0'}
                        </span>
                      </div>
                      <hr></hr>
                      <div className="">
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="fw-bold">Tagihan talangin</p>
                          <p className="fw-bold text-primary">
                            Rp
                            {amountToPay
                              ? newFormatThousandSeparator(amountToPay, 0)
                              : '0'}
                          </p>
                        </div>

                        {data?.partialpayments && (
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Pembayaran tagihan</span>
                            <span className="text-primary">
                              Rp
                              {newFormatThousandSeparator(
                                data?.partialpayments?.reduce(
                                  (sum, e) => sum + e.paymentAmount,
                                  0,
                                ),
                                0,
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                      <>
                        <hr></hr>
                        <div className="d-flex justify-content-between align-items-center">
                          <p>Sisa Tagihan</p>
                          <p className="text-primary">
                            Rp
                            {amountToPay
                              ? newFormatThousandSeparator(amountToPay, 0)
                              : '0'}
                          </p>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default DetailTalanginInvoice
